import { JSXElementConstructor } from "react";
import {
  // Controller,
  Control,
  FieldValues,
  useForm,
  UseFormProps,
} from "react-hook-form";

// export const wrapWithForm = (
//   Component: any,
//   compProps?: any,
//   formProps?: any

export const wrapWithForm = <T extends FieldValues>(
  component: JSXElementConstructor<{ control: Control<T> }>,
  compProps?: unknown,
  formProps?: UseFormProps<T>
) => {
  const Form = () => {
    const { control } = useForm(formProps);
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    const Component = component as any;

    return <Component as any control={control} />;
  };

  return <Form />;
};
